import SidebarBookingsRepliesNewRoute from 'uplisting-frontend/pods/-sidebar/bookings/replies/new/route';

export default class ProtectionOverviewBookingsRepliesNewRoute extends SidebarBookingsRepliesNewRoute {
  parentRoute = 'protection.overview.bookings';
}
